import { SEARCH_TEXT_MIN_LENGTH } from './Search.constants'

/**
 * @param {SearchValue} value
 *
 * @returns {boolean}
 */
export function isValidSearchValue(value) {
  return (
    value.type != null && value.text.trim().length >= SEARCH_TEXT_MIN_LENGTH
  )
}

/**
 * @param {SearchValue} search
 * @param {SearchType} type
 *
 * @returns {SearchValue}
 */
export function setSearchValueType(search, type) {
  return search.type === type ? search : { ...search, type }
}

/**
 * @param {SearchValue} search
 * @param {string} text
 *
 * @returns {SearchValue}
 */
export function setSearchValueText(search, text) {
  return search.text === text ? search : { ...search, text }
}

/**
 * @param {SearchValue} search
 * @param {boolean} archived
 *
 * @returns {SearchValue}
 */
export function setSearchValueArchived(search, archived) {
  return search.archived === archived ? search : { ...search, archived }
}
